(() => {
  if (window.cfFiberTooltips) {
    window.cfFiberTooltips.init();
    return;
  }
  const names = {
  "BA": "Bamboo",
  "CA": "Hemp",
  "CO": "Cotton",
  "EA": "Elastane",
  "EU": "Eucalyptus",
  "LI": "Linen",
  "LY": "Lyocell",
  "MD": "Modal",
  "ME": "Metallic fiber",
  "LUREX": "Lurex",
  "PA": "Polyamide",
  "PC": "Acrylic",
  "PL": "Polyester",
  "PU": "Polyurethane",
  "RA": "Ramie",
  "SE": "Silk",
  "TN": "Tencel",
  "VI": "Viscose",
  "WA": "Angora",
  "WG": "Vicuña",
  "WK": "Camel",
  "WL": "Llama",
  "WM": "Mohair",
  "WO": "Wool",
  "WP": "Alpaca",
  "WS": "Cashmere",
  "WV": "Merino",
  "WY": "Yak",
  "WVR": "Recycled merino",
  "WSR": "Recycled cashmere",
  "OF": "Other fibers",
  "HE": "Hemp",
  "CLY": "Lyocell",
  "PBT": "Polybutylene terephthalate (PBT)"
};
  let active = null;
  let pinned = false;
  const popup = document.createElement('div');
  popup.id = 'cf-fiber-tooltip';
  popup.setAttribute('role','tooltip');
  popup.hidden = true;
  document.body.appendChild(popup);
  function close() {
    if (active) {
      active.setAttribute('aria-expanded','false');
      active.removeAttribute('aria-describedby');
    }
    active = null;
    pinned = false;
    popup.hidden = true;
  }
  function position() {
    if (!active || !active.isConnected) { close(); return; }
    const r = active.getBoundingClientRect();
    const p = popup.getBoundingClientRect();
    const width = document.documentElement.clientWidth;
    const left = Math.max(12,Math.min(r.left,width-p.width-12));
    const below = r.bottom + 7;
    const top = below+p.height <= window.innerHeight-12 ? below : Math.max(12,r.top-p.height-7);
    popup.style.left = left+'px';
    popup.style.top = top+'px';
  }
  function show(button, pin) {
    if (active !== button) close();
    active = button;
    pinned = pin;
    popup.textContent = button.dataset.fiberMeaning;
    popup.hidden = false;
    button.setAttribute('aria-expanded','true');
    button.setAttribute('aria-describedby',popup.id);
    position();
  }
  function init() {
    document.querySelectorAll('[data-fiber-composition]:not([data-fiber-ready])').forEach(row => {
      row.dataset.fiberReady = 'true';
      const text = row.textContent;
      const fragment = document.createDocumentFragment();
      const re = /(\d+(?:[.,]\d+)?)\s*%?\s*([A-Za-z]+)|\b([A-Za-z]+)\b/g;
      let cursor = 0;
      let match;
      while ((match = re.exec(text)) !== null) {
        const name = names[(match[2] || match[3]).toUpperCase()];
        if (!name) continue;
        fragment.appendChild(document.createTextNode(text.slice(cursor,match.index)));
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cf-fiber-code';
        button.textContent = match[0];
        button.dataset.fiberMeaning = (match[1] ? match[1]+'% ' : '')+name;
        button.setAttribute('aria-label',button.dataset.fiberMeaning);
        button.setAttribute('aria-expanded','false');
        fragment.appendChild(button);
        cursor = re.lastIndex;
      }
      if (!cursor) return;
      fragment.appendChild(document.createTextNode(text.slice(cursor)));
      row.replaceChildren(fragment);
    });
    document.querySelectorAll('.fiber-comp-legend-name:not([data-fiber-detail-ready])').forEach(label => {
      const key = label.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g,'_').replace(/^_|_$/g,'');
      const alias = {rayon:'viscose',nylon:'polyamide',shetland:'shetland_wool',polyacrylic:'acrylic',polybutylene_terephthalate_pbt:'pbt'};
      const data = document.querySelector('[data-fiber-descriptions]');
      if (!data) return;
      let descriptions;
      try { descriptions = JSON.parse(data.textContent); } catch (_) { return; }
      const description = descriptions[alias[key] || key];
      if (!description) return;
      label.dataset.fiberDetailReady = 'true';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cf-fiber-code cf-fiber-detail';
      button.textContent = label.textContent;
      button.dataset.fiberMeaning = description;
      button.setAttribute('aria-expanded','false');
      label.replaceChildren(button);
    });

  }
  document.addEventListener('click',event => {
    const button = event.target.closest('.cf-fiber-code');
    if (button) {
      if (active === button && pinned) close();
      else show(button,true);
    } else if (!popup.contains(event.target)) close();
  });
  document.addEventListener('pointerover',event => {
    if (!matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    const button = event.target.closest('.cf-fiber-code');
    if (button && active !== button) show(button,false);
  });
  document.addEventListener('pointerout',event => {
    if (pinned || !active) return;
    const next = event.relatedTarget;
    if (next && (active.contains(next) || popup.contains(next))) return;
    if (active.contains(event.target) || popup.contains(event.target)) close();
  });
  document.addEventListener('focusin',event => {
    const button = event.target.closest('.cf-fiber-code');
    if (button && active !== button) show(button,false);
  });
  document.addEventListener('focusout',event => {
    if (!pinned && active && active.contains(event.target) && !active.contains(event.relatedTarget)) close();
  });
  document.addEventListener('keydown',event => {
    if (event.key === 'Escape') close();
  });
  window.addEventListener('resize',close);
  window.addEventListener('scroll',() => { if (active) position(); },true);
  document.addEventListener('shopify:section:load',init);
  window.cfFiberTooltips = {init};
  init();
})();